type Params = {
  height?: number;
  width?: number;
};

const FORMATS_TO_CONVERT = ['.heic', '.heif', '.webp'];

/*
 * https://docs.imgix.com/getting-started/setup/serving-assets
 * https://www.datocms.com/docs/asset-api/images
 */
export default function applyImageOptimizations(
  url: string | null | undefined,
  params: Params = {},
): string {
  if (!url || isSrcSet(url) || !containsDomain(url, 'datocms-assets.com')) {
    return url || '';
  }

  const shouldConvert = FORMATS_TO_CONVERT.some((format) =>
    url.toLowerCase().includes(format),
  );
  const format = shouldConvert ? 'png' : undefined;

  let result = `${url}${
    url.includes('?') ? '&' : '?'
  }auto=format,compress&q=60`;

  if (format) {
    result += `&fm=${format}`;
  }

  if (params.width) {
    result += `&w=${params.width}`;
  }

  if (params.height) {
    result += `&h=${params.height}`;
  }

  return result;
}

function isSrcSet(url: string): boolean {
  return /https?:\/\/[\S]+?\s\d+w(,\s*https?:\/\/[\S]+?\s\d+w)*/.test(url);
}

function containsDomain(url: string, domain: string): boolean {
  try {
    const { hostname } = new URL(url);
    return hostname === domain || hostname.endsWith(`.${domain}`);
  } catch (e) {
    return false;
  }
}
